var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listado},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":item.createdAt}})]}},{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{staticClass:"mx-2",attrs:{"small":"","color":_vm.tipoLista.find(function (ref) {
	var tipo = ref.tipo;

	return tipo=== item.tipo;
}).color}},[_vm._v("\n        "+_vm._s(_vm.tipoLista.find(function (ref) {
	var tipo = ref.tipo;

	return tipo=== item.tipo;
}).nombre)+"\n        ")])]}},{key:"item.correoElectronico",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("mailto:" + (item.correoElectronico))}},[_vm._v(_vm._s(item.correoElectronico))])]}},{key:"item.celular",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("tel:" + (item.celular))}},[_vm._v(_vm._s(item.celular))])]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.editar(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v("Editar")])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.borrar(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}],null,true)},[_c('span',[_vm._v("Borrar")])])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }